import { useLanguage } from "../../../lib/LanguageContext";
import FieldSwitcher from "../FieldSwitcher";
import FormGroup from "../FormGroup";
import SelectGroup from "../SelectGroup";

interface IInstrumentInput {
  instruments: IInstrument[];
  switches: ISwitch[];
  setSwitches: (s: ISwitch[]) => void;
  setSelectedInstrument: (i: IInstrument | undefined) => void;
  selectedInstrument: IInstrument | undefined;
  className?: string;
}

function InstrumentInput({
  instruments,
  switches,
  setSwitches,
  setSelectedInstrument,
  selectedInstrument,
  className,
}: IInstrumentInput) {
  const { languageData } = useLanguage();

  const changeInstrument = (ins: string | number) => {
    const instrument =
      instruments[instruments.findIndex((i) => i.SymbolName === ins)];
    setSelectedInstrument(instrument);
  };

  return (
    <div className={className || "col-12"}>
      <div className="row" style={{ alignItems: "baseline" }}>
        <div className="col-6">
          <SelectGroup
            label={languageData.instrument}
            options={instruments
              .filter((ins) => ins.show)
              .map((ins) => ({
                value: ins.SymbolName,
                name: ins.DisplaySymbolName,
                longnote: ins.FullName,
                shortnote: ins.SymbolName,
                selected:
                  selectedInstrument &&
                  selectedInstrument.DisplaySymbolName ===
                    ins.DisplaySymbolName,
              }))}
            setValue={changeInstrument}
          />
        </div>
        <div className="col-6">
          <FormGroup label={" "}>
            <FieldSwitcher switches={switches} setSwitches={setSwitches} />
          </FormGroup>
        </div>
      </div>
    </div>
  );
}

export default InstrumentInput;
